if (!customElements.get('collection-load-more')) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      // Configurations
      this.products_on_page = document.getElementById('product-grid');
      this.isLoading = false;
      this.hasMorePages = true;

      this.loadMoreProducts = this.loadMoreProducts.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      document.addEventListener('change', () => {
        this.initCollectionLoadMore();
      });
    }

    connectedCallback() {
      this.initCollectionLoadMore();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.handleScroll);
      document.removeEventListener('click', this.loadMoreProducts);
    }

    initCollectionLoadMore() {
      // Re-query elements since filters may replace innerHTML
      this.loadMoreButton = this.querySelector('#paginate-next');

      if (!this.loadMoreButton) return;

      this.hasMorePages = !this.loadMoreButton.classList.contains('hidden');

      document.addEventListener('click', this.loadMoreProducts, false);
      document.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    async getNextPage(next_url) {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log(error);
      }
    }

    handleScroll() {
      if (this.isLoading || !this.hasMorePages) return;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollableHeight = documentHeight - windowHeight;

      if (scrollableHeight <= 0) return;

      const scrollPercentage = scrollPosition / scrollableHeight;

      // Trigger when user has scrolled 50% down the page
      if (scrollPercentage >= 0.5) {
        this.loadMoreProducts(undefined, true);
      }
    }

    async loadMoreProducts(e, isInfiniteScroll = false) {
      // If triggered by click, validate target
      if (!isInfiniteScroll) {
        const paginateButton = e.target.closest('#paginate-next');
        if (!paginateButton) return;
      }

      // Prevent concurrent loads and stop if no more pages
      if (this.isLoading || !this.hasMorePages) return;

      // Re-query elements as filters may have replaced innerHTML
      this.loadMoreButton = this.querySelector('#paginate-next');
      const paginateButton = this.loadMoreButton;
      if (!paginateButton) return;

      // Trust the button in the DOM over cached state. Applying a filter swaps this button
      // out for the filtered result's button, which is hidden with an empty href when there
      // is only one page. Without this check we would fetch '' - the current URL - and append
      // the page's own products to itself, duplicating every card.
      const nextUrl = paginateButton.dataset.href;
      if (!nextUrl || paginateButton.classList.contains('hidden')) {
        this.hasMorePages = false;
        return;
      }

      this.isLoading = true;

      if (!isInfiniteScroll) {
        paginateButton.disabled = true;
        const spinner = paginateButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      let nextPage = await this.getNextPage(nextUrl);
      if (!nextPage) {
        this.isLoading = false;
        return;
      }

      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
      const productgrid = nextPageDoc.getElementById('product-grid');
      const new_products = productgrid.querySelectorAll('.product-grid__item');
      const newUrl = nextPageDoc.getElementById('paginate-next');

      if (newUrl && newUrl.dataset.href.length > 0) {
        paginateButton.dataset.href = newUrl.dataset.href;
        paginateButton.innerHTML = newUrl.innerHTML;

        if (!isInfiniteScroll) {
          const spinner = paginateButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          paginateButton.disabled = false;
        } else {
          // Re-show the button (may have been visually disabled)
          paginateButton.disabled = false;
        }
      } else {
        paginateButton.classList.add('hidden');
        this.hasMorePages = false;
      }

      // Re-query the grid: filtering replaces its contents, and the cached reference from the
      // constructor can point at a grid that no longer reflects what is on screen.
      const grid = document.getElementById('product-grid') || this.products_on_page;
      const existingHandles = new Set(
        Array.from(grid.querySelectorAll('[data-product-handle]')).map(
          (card) => card.dataset.productHandle
        )
      );

      for (let i = 0; i < new_products.length; i++) {
        const handle = new_products[i].querySelector('[data-product-handle]')?.dataset
          .productHandle;

        // A stale next-page URL can overlap the products already shown, so never append a
        // product twice.
        if (handle && existingHandles.has(handle)) continue;
        if (handle) existingHandles.add(handle);

        grid.appendChild(new_products[i]);
      }

      this.isLoading = false;
    }
  }

  customElements.define('collection-load-more', CollectionLoadMore);
}
